export const Countries = {
  DEU: 'Deutschland',
  CHE: 'Schweiz',
  AUT: 'Österreich',
}

export const PASSWORD_REGEXP = '^(?=.*[a-z])(?=.*[A-Z]).+$'
export const DOWNLOAD_FILE_REACT_NATIVE_MESSAGE_TYPE = 'download-file'
export const APP_VERSION_UPDATE_DATE_KEY = 'app_version_update_date'
